import script from "./ProcessedAnswersOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessedAnswersOverview.vue?vue&type=script&setup=true&lang=js"

import "./ProcessedAnswersOverview.vue?vue&type=style&index=0&id=cebd52e4&lang=css"

const __exports__ = script;

export default __exports__